import React from 'react';

import {ResponsiveElementGroup} from 'src/components/responsive-element-group';
import {FormItemSkeleton, FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';

export const UserDetailsSkeleton = () => (
    <FormSectionSkeleton labelWidth={120}>
        <ResponsiveElementGroup>
            <FormItemSkeleton labelWidth={70}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={50}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={50}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={70}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={50}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={50}>
                <SkeletonItem width={300} height={32}/>
            </FormItemSkeleton>
        </ResponsiveElementGroup>
    </FormSectionSkeleton>
);
